import React from 'react';
import {Text, View} from 'native-base';
import {useTheme} from 'styled-components/native';
import {
  useIsDesktop,
  useIsLargeDesktop,
} from '@eCommerce/frontend-legacy-shared-library-native';

export interface AttributeProps {
  attribute: string;
  value: string;
}

const Attribute: React.FC<AttributeProps> = ({attribute, value}) => {
  const {colors} = useTheme() as any;
  const {paleSky, tuna} = colors;
  const isDesktop = useIsDesktop();
  const isLargeDesktop = useIsLargeDesktop();

  return (
    <View marginBottom="8px">
      <Text
        color={paleSky}
        fontSize={isDesktop ? 'md' : 'xs'}
        marginBottom="4px"
        testID={`${attribute}-label`}>
        {attribute}
      </Text>
      <Text
        color={tuna}
        fontSize={isDesktop ? 'lg' : 'sm'}
        fontWeight="700"
        paddingRight={isDesktop ? undefined : '20px'}
        maxWidth={isDesktop && !isLargeDesktop ? '360px' : undefined}
        testID={`${attribute}-value-label`}>
        {value}
      </Text>
    </View>
  );
};

export default Attribute;
